export type TWithdrawalTransactionStatus =
  | 'Принят'
  | 'Готов к выводу'
  | 'Заявка на вывод'
  | 'Ожидает вывода'
  | 'Ожидает 7 дней'
  | 'Выведено'
  | 'Ожидается доставка до покупателя'
  | 'Заказ был отменён'
  | 'Заказ был отменен'

export interface IAdminTransactionsRequest
  extends Components.Schemas.IAdminGetTransactionsRequest {
  status?: TWithdrawalTransactionStatus | TWithdrawalTransactionStatus[] | string | string[]
}
export interface IAdminTransactionsResponse extends Components.Schemas.IAdminTransactionsQueryResponse {}
export interface ITransaction extends Components.Schemas.ISellerTransactions {
  order_number?: string | number | null
  order_created_at?: string | null
  status?: TWithdrawalTransactionStatus | string | null
  // credited_sum — сумма для журнала транзакций, не меняется после возвратов в отличие от sum
  credited_sum?: number | null
  withdrawal_request_id?: string | null
}
export interface IAdminCreateSellerTransactionRequest extends Components.Schemas.IAdminCreateSellerTransactionRequest {}
export interface IAdminAddRefundTransactionRequest extends Components.Schemas.IAdminAddCustomRefundTransactionRequest {}

export enum ESellerTransactionsType {
  SALE = 'SALE',
  FINE = 'FINE',
  WITHDRAW = 'WITHDRAW',
  REFUND = 'REFUND',
}

export enum EOrderTransactionType {
  PAYMENT = 'PAYMENT',
  REFUND = 'REFUND',
}

export enum EOrderRefundReason {
  ITEM_CANCEL = 'ITEM_CANCEL',
  ORDER_CANCEL = 'ORDER_CANCEL',
  ORDER_RETURN = 'ORDER_RETURN',
  CONFIRM_DIFFERENCE = 'CONFIRM_DIFFERENCE',
  MANUAL = 'MANUAL',
}

// Деньги покупателя по заказу в ЮKassa: оплата с плюсом, возврат с минусом
export interface IOrderTransaction {
  _id: string
  type: EOrderTransactionType
  sum: number
  payment_id: string
  refund_id?: string
  status?: string
  reason?: EOrderRefundReason
  comment?: string
  createdAt: string
}

export interface IOrderTransactionsResponse {
  transactions: IOrderTransaction[]
}
